// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__xgtR0 {
  background-color: var(--blue);
}
.Footer_footer__xgtR0 .Footer_innerFooter__DDA5T {
  width: 100%;
  padding: 1px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.Footer_footer__xgtR0 p {
  padding: 0;
  margin: 0px;
  margin-bottom: 1px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AACJ;AAEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAAJ","sourcesContent":[".footer {\n  background-color: var(--blue);\n\n  .innerFooter {\n    width: 100%;\n    padding: 1px;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n  }\n\n  p {\n    padding: 0;\n    margin: 0px;\n    margin-bottom: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__xgtR0`,
	"innerFooter": `Footer_innerFooter__DDA5T`
};
export default ___CSS_LOADER_EXPORT___;
